var _defs, _style, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWolf(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 2049,
    height: 1152,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "P",
    gradientUnits: "userSpaceOnUse"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g1",
    x1: 1269.9,
    x2: 1323.2,
    y1: 510.9,
    y2: 508.5,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#f3d6d2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a59ac2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g2",
    x1: 1285.3,
    x2: 1338.7,
    y1: 507.2,
    y2: 505,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a59ac2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g3",
    x1: 1309.7,
    x2: 1357,
    y1: 567.1,
    y2: 565.2,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#f3d6d2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a59ac2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g4",
    x1: 1317.2,
    x2: 1317.2,
    y1: 678.9,
    y2: 543.5,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a59ac2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g5",
    x1: 1658.3,
    x2: 1850.8,
    y1: 491.6,
    y2: 491.6,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#a59ac2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f3d6d2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g6",
    x1: 1605.6,
    x2: 1543.3,
    y1: 739.3,
    y2: 801.8,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#a59ac2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f3d6d2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g7",
    x1: 1442.9,
    x2: 1543.4,
    y1: 560.9,
    y2: 561,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#f3d6d2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a59ac2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g8",
    x1: 1584.5,
    x2: 1642.5,
    y1: 747.2,
    y2: 680.3,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#f3d6d2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a59ac2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g9",
    x1: 1587.7,
    x2: 1749.9,
    y1: 494,
    y2: 494,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#a59ac2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g10",
    x1: 1613.9,
    x2: 1760.3,
    y1: 491.6,
    y2: 491.6,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#a59ac2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g11",
    x1: 1480.7,
    x2: 1480.7,
    y1: 678.2,
    y2: 565.7,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a59ac2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g12",
    x1: 1358.8,
    x2: 1619.2,
    y1: 461.3,
    y2: 461.3,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#f3d6d2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a59ac2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g13",
    x1: 1529.8,
    x2: 1529.8,
    y1: 608.9,
    y2: 474.7,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a59ac2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g14",
    x1: 1524.2,
    x2: 1630.1,
    y1: 461.3,
    y2: 461.3,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#a59ac2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g15",
    x1: 1291.2,
    x2: 1578.6,
    y1: 437.2,
    y2: 437.2,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#f3d6d2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a59ac2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g16",
    x1: 1416.6,
    x2: 1481.6,
    y1: 515.9,
    y2: 433.5,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a59ac2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g17",
    x1: 1585.5,
    x2: 1637.4,
    y1: 488.7,
    y2: 578.5,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#a59ac2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g18",
    x1: 1368.8,
    x2: 1502.3,
    y1: 451.8,
    y2: 388.1,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#a59ac2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g19",
    x1: 1241.2,
    x2: 1520.5,
    y1: 400.1,
    y2: 400.1,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#f3d6d2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a59ac2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g20",
    x1: 1389.6,
    x2: 1473.3,
    y1: 404.4,
    y2: 386.2,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#a59ac2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g21",
    x1: 1393.6,
    x2: 1393.6,
    y1: 590.8,
    y2: 400.1,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#a59ac2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g22",
    x1: 1315.3,
    x2: 1473.3,
    y1: 621.5,
    y2: 420.9,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#a59ac2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g23",
    x1: 1214,
    x2: 1504.2,
    y1: 431.2,
    y2: 265,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#f3d6d2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a59ac2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g24",
    x1: 1440.2,
    x2: 1498.1,
    y1: 447.6,
    y2: 548.9,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a59ac2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g25",
    x1: 1253.7,
    x2: 1277.9,
    y1: 407.1,
    y2: 380,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a59ac2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g26",
    x1: 1267.1,
    x2: 1395.5,
    y1: 571,
    y2: 232.7,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a59ac2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g27",
    x1: 1316.1,
    x2: 1320.1,
    y1: 463.3,
    y2: 470.2,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#a59ac2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g28",
    x1: 1426.1,
    x2: 1444.4,
    y1: 434.1,
    y2: 465.8,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#a59ac2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g29",
    x1: 1338.3,
    x2: 1338.3,
    y1: 533.1,
    y2: 348,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a59ac2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g30",
    x1: 1279.2,
    x2: 1279.2,
    y1: 526.3,
    y2: 412.4,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a59ac2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g31",
    x1: 1270.7,
    x2: 1299.9,
    y1: 390.8,
    y2: 390.8,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#3e1e43"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2d1536"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g32",
    x1: 1303.8,
    x2: 1490.9,
    y1: 247.6,
    y2: 358.5,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#f3d6d2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a59ac2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g33",
    x1: 1366.6,
    x2: 1366.6,
    y1: 425.2,
    y2: 317.7,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#a59ac2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g34",
    x1: 1228.7,
    x2: 1228.7,
    y1: 420.4,
    y2: 343.2,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#a59ac2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g35",
    x1: 1349.3,
    x2: 1464.2,
    y1: 259.9,
    y2: 366.1,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a59ac2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g36",
    x1: 1350.1,
    x2: 1317.3,
    y1: 442,
    y2: 451.5,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffc293"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g37",
    x1: 1319.4,
    x2: 1356.1,
    y1: 282,
    y2: 345.6,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#a59ac2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g38",
    x1: 1295.1,
    x2: 1335.4,
    y1: 287.7,
    y2: 357.3,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#a59ac2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g39",
    x1: 1473.8,
    x2: 1506.6,
    y1: 509.3,
    y2: 532.9,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#f3d6d2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a59ac2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g40",
    x1: 1425.2,
    x2: 1488.2,
    y1: 573.8,
    y2: 570.7,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#f3d6d2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a59ac2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g41",
    x1: 1375.4,
    x2: 1375.4,
    y1: 327.6,
    y2: 309.8,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a59ac2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g42",
    x1: 1260.6,
    x2: 1301.2,
    y1: 294.6,
    y2: 286.9,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#a59ac2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g43",
    x1: 1330.3,
    x2: 1330.3,
    y1: 350.4,
    y2: 314.5,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a59ac2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g44",
    x1: 1241.7,
    x2: 1241.7,
    y1: 387.3,
    y2: 351.9,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a59ac2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g45",
    x1: 1273.3,
    x2: 1269.6,
    y1: 399.8,
    y2: 369.8,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a59ac2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g46",
    x1: 1356.5,
    x2: 1437.2,
    y1: 229.3,
    y2: 254.6,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#f3d6d2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a59ac2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g47",
    x1: 1238.5,
    x2: 1321.9,
    y1: 266.1,
    y2: 296,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#f3d6d2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a59ac2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g48",
    x1: 1434.2,
    x2: 1434.2,
    y1: 590.7,
    y2: 517.6,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a59ac2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g49",
    x1: 1308.5,
    x2: 1301.1,
    y1: 458.3,
    y2: 442.1,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a59ac2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g50",
    x1: 1556.1,
    x2: 1713.2,
    y1: 462.2,
    y2: 564.9,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#f3d6d2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a59ac2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g51",
    x1: 1243.9,
    x2: 1319,
    y1: 273,
    y2: 324.1,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#a59ac2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g52",
    x1: 1590.5,
    x2: 1590.5,
    y1: 680.7,
    y2: 522.3,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a59ac2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g53",
    x1: 1501.6,
    x2: 1478.2,
    y1: 539.4,
    y2: 584.6,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3e1e43"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#502b74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3e1e43"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g54",
    x1: 1633.8,
    x2: 1651.4,
    y1: 533,
    y2: 592.7,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3e1e43"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#502b74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3e1e43"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g55",
    x1: 1270.8,
    x2: 1270.8,
    y1: 385.9,
    y2: 328.8,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffc293"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g56",
    x1: 1325.7,
    x2: 1373.2,
    y1: 236.6,
    y2: 236.6,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffc293"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g57",
    x1: 1222.1,
    x2: 1275.9,
    y1: 263.5,
    y2: 263.5,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#a59ac2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g58",
    x1: 1563.8,
    x2: 1563.8,
    y1: 751.1,
    y2: 664.5,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a59ac2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g59",
    x1: 1647,
    x2: 1647,
    y1: 783.7,
    y2: 687.5,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a59ac2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g60",
    x1: 1435.8,
    x2: 1435.8,
    y1: 729,
    y2: 477.4,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a59ac2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g61",
    x1: 1356.8,
    x2: 1420.5,
    y1: 455.9,
    y2: 455.9,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffc293"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g62",
    x1: 1280.3,
    x2: 1349.5,
    y1: 462.8,
    y2: 462.8,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffc293"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g63",
    x1: 1442.3,
    x2: 1468.7,
    y1: 515.4,
    y2: 515.4,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffc293"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g64",
    x1: 1430.2,
    x2: 1462.6,
    y1: 599.9,
    y2: 599.9,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffc293"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g65",
    x1: 1581.1,
    x2: 1596.7,
    y1: 521.8,
    y2: 521.8,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffc293"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g66",
    x1: 1386.7,
    x2: 1373.2,
    y1: 303,
    y2: 319.9,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#a59ac2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g67",
    x1: 1352.8,
    x2: 1350.1,
    y1: 313.6,
    y2: 289.6,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4f395f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3e1e43"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g68",
    x1: 1384.6,
    x2: 1416.2,
    y1: 251.2,
    y2: 336.5,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#a59ac2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })))), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".c{fill:#3e1e43}.d{fill:#6f5175}.e,.j{mix-blend-mode:multiply}.e{opacity:.7;fill:#a59ac2}.j{fill:#8880a8}.Z{fill:#d6ffff}.a6,.al{mix-blend-mode:multiply;fill:#a59ac2}.al{opacity:.5;fill:#3e1e43}")), /*#__PURE__*/React.createElement("path", {
    d: "M1282.1 514c-17.2 20.4 18.1 71.2 58.3 57.8 40.2-13.4-58.3-57.8-58.3-57.8z",
    style: {
      fill: "url(#g1)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1290.7 510.8c-17.3 20.5 18.1 71.2 58.2 57.8 40.3-13.5-58.2-57.8-58.2-57.8z",
    style: {
      mixBlendMode: "multiply",
      fill: "url(#g2)"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1366.4 784.4s4.7-14.7-2.7-37.5c-3.6-11-4-20.4-18.2-59.9-8.3-23.3-11.5-26.2-1.6-27.8 11.2-2 21.1-.9 24 8.4 6.3 19.8 8.3 43.1 14.8 59.6 3.5 8.3 15.6 20.9 16.8 44 1.3 20.6 0 24.8 0 24.8z",
    className: "c"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1332.9 796c7.6-29.7 18.5-19.7 18.5-19.7 14.6-12.3 23.2 1.6 23.2 1.6 14.6-8.5 24.9 18.1 24.9 18.1-39.8 10.8-66.6 0-66.6 0z",
    className: "d"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1332.9 796q.6-1.9 1.1-3.5s3.6 3.5 11.2 2.3c0 0-2.9-6.4 6.2-18.5 0 0-3.2 11.2 0 18.8 0 0 6.2 3.5 16 .9 0 0-2.9-9.9 7.2-18.1 0 0-3.8 11 0 18.1 0 0 15.1 1.9 22.9.5-38.8 9.8-64.6-.5-64.6-.5z",
    className: "e"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1355.3 714.5c-16.1-18.1-37-77.6-45.4-109.1-5.1-18.8 1.3-32.3 14.6-35 2.6-.5 4.7-.5 5.6.2 7.2 5.5 9.7-1.3 19.2.6q1.1.2 2 .3c1.3 3.6 2.8 8 4.5 13.6 13 41.8 21.8 154.6-.5 129.4z",
    style: {
      fill: "url(#g3)"
    }
  }), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1330 565.3c-3.3 5.7-11.4 24.5-15.3 26.1-4 1.8-3.3-11.6-4.1-16.2-.7-4.6-7.6-14.9-7.6-14.9s13.1 10.7 19.8 7.8c9.4-3.9 7.2-2.8 7.2-2.8z",
    className: "c"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1366.8 710.1c-3.1 11.4-14.6.6-30.4-54-9.2-31.2-13.2-51.1-14.1-63.3-.8-8.1 5.5-15.5 14.7-17.7 2.4-.6 4.3-1.3 5-2.5 1 .1-12.3-2.3-11.9-2 7.2 5.5 9.7-1.3 19.2.6q1.1.2 2 .3c1.3 3.6 2.8 8 4.5 13.6 9.7 31.1 17 101.3 11 125z",
    style: {
      mixBlendMode: "multiply",
      fill: "url(#g4)"
    }
  }), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m1361.2 607.8-38.6-11.9q-.3-1.8-.5-3.3c-.5-8 5.6-15.3 14.5-17.4 2.5-.6 4.7-1.4 5.4-2.6 1 .1-12.3-2.3-11.9-2 7.2 5.5 9.7-1.3 19.2.6q1.1.2 2 .3c1.3 3.6 2.8 8 4.5 13.6 1.9 6.2 3.7 14.1 5.4 22.7z",
    className: "d"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M1383.3 296.8c4.1 2.3 7.7 5.3 9.6 9.2 1.9 4.1 1.9 8.7-.3 12.7-.5.9-2 .1-1.5-.7 2.1-3.7 2-8 0-11.6-1.8-3.5-4.9-6.3-8.7-8.3-.9-.4-.1-1.8.9-1.3z",
    className: "c"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M1379.1 277.3c3.9 1.5 7.6 3 10.5 5.6 4.6 4.2 6.3 10.3 3.6 15.7-2.5 5.1-9.3 8.1-15.5 6.7-1.1-.2-.7-1.8.5-1.4 3 .7 6.3.1 9.1-1.4 5.1-2.8 6.6-8.7 4.6-13.5-.9-2.3-2.7-4.4-4.8-6-2.5-1.9-5.5-3.1-8.5-4.1-1-.5-.6-1.9.5-1.6zM1649.7 568.3c21.3 38.5 62.7 38.8 95.4 43.8q1.8.2 3.5.6c24.9 4.8 31.8 33.1 11 45.9-15.9 9.7-41.7 16.1-79.5 8.6-65.8-13.1-85.8-102.3-85.8-102.3s33.8-35 55.4 3.4z",
    className: "c"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1603.7 500.7c54.2 25.5 43.2 72.3 73.7 92.3 22.6 15 84.3 20 84.3 20l6.6 7.1s11 48.3-73.7 21c-64.5-20.8-62.1-92.6-62.1-92.6s-83-73.4-28.8-47.8z",
    style: {
      fill: "url(#g5)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1572.1 682c9.5 0 15.9 64.5 1.8 86.6l-42.2-3s13.7-7.3 21.8-42.3c8.1-35.1 11.9-41.2 18.6-41.3z",
    style: {
      fill: "url(#g6)"
    }
  }), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m1717.4 643.7-9.3 1.4q-1.7-.5-3.7-1l11.9-1.8 9.6-13.4-1.1-7.3-1.1-.8-24.9-18.7q2 .7 4.2 1.3l23.5 17.5 1.4 8.3zM1560.4 718.1h1.6c-1.2 23-16 39.5-16.1 39.6l-.5-.3-.9-.6c.2-.2 14.7-16.2 15.9-38.7z",
    className: "j"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M1371.5 585.6c-.2 4 .3 8.1 1.7 12 1.2 3.3 2.9 7 5.8 9.4 1.4 1.3 3.2 2.1 4.9 2.8 2 .9 4 1.4 6.1 1.6 4.6.2 7.3-2.6 9.7-5.6q3.3-4.4 4.9-9.5c.3-.9 2-.6 1.7.4-1.2 4.2-3.5 8.3-6.6 11.7-1.3 1.4-2.6 2.7-4.4 3.6-2 .8-4 1-6.2.8-4.3-.5-8.9-2.4-11.8-5.1-3-2.8-4.8-6.6-5.9-10.2-1.4-3.9-1.9-7.9-1.5-11.9 0-.9 1.8-.9 1.6 0zM1564.1 677.5c0 9.5 5.1 11.7 5.1 11.7.3 25.9-9.9 42.2-9.9 42.2 0-6.3-9.8-45.1-27.6-64.5 0 0 32.4 1.1 32.4 10.6z",
    className: "c"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1519.4 565.3s38.6 11.9 29.3 31.3c-9.4 19.5-4.3 53.3 9.1 68 13.4 14.6 22 24.4-15.2 11.2-37.3-13.1-58.1-50.6-64.6-91z",
    style: {
      fill: "url(#g7)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1655.2 687.4c10.9.5 29.5 60.3 19.1 96.3l-55.4-4.3s13-19.5 19.7-52.2c6.6-32.8 8.4-40.2 16.6-39.8z",
    style: {
      fill: "url(#g8)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1749.9 635.3-9.2 14.1c-10.8.5-25.7-1.6-46.1-8.3-64.5-20.8-62.1-92.6-62.1-92.6s-35.3-31.2-44.8-45.9c3.6-1.4 7.6-2.8 11.6-3.9q2.1.9 4.4 2c50 23.5 44.6 64.9 67.1 87.1 22.6 27.4 72.2 38.5 72.2 38.5z",
    style: {
      mixBlendMode: "multiply",
      fill: "url(#g9)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1694.6 641.1c-28.3-9.1-43.7-28-52.1-46.4-10.8-23.5-10-46.2-10-46.2s-83-73.4-28.8-47.8c30.2 14.2 40.2 35 48.3 54.2-8.7-18.2-4.4 19.6 9.2 48.4 13.6 28.7 87.4 35.7 100.5 9.7l6.6 7.1s11 48.3-73.7 21z",
    style: {
      mixBlendMode: "multiply",
      fill: "url(#g10)"
    }
  }), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M1477.3 648.4c-7.7 58.3-24.5 66.8-8.6 100.5 5.3 11.2.6 64.7.6 64.7l-48.1-8.3s17.1-42.8 14.6-58.8c-2.3-15.9-1.2-41.4-3.7-53.3 0 0 52.8-103.2 45.2-44.8z",
    className: "c"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M1650.3 728.9q0 .6-.1 1.1-.1 2-.3 3.9-.1.5-.1 1l-.6 3.8q-.1.6-.2 1-.3 1.9-.7 3.8-.2.5-.3 1.1-.4 1.7-.8 3.5-.2.3-.2.8-.5 1.9-1.1 3.6 0 .3-.1.5-.6 1.9-1.1 3.8-.2.1-.2.2-.6 1.9-1.2 3.6-.1.3-.1.4-.7 1.8-1.3 3.3 0 .1-.1.1-.6 1.6-1.3 3.2 0 .1-.1.2-.5 1.4-1.1 2.7 0 .1-.1.2-.6 1.2-1 2.2-.1.2-.1.3-.5.9-.9 1.8v.1q-.4.7-.7 1.3c-.1.1-.1.2-.1.2q-.3.5-.4.7c0 .3-.1.3-.1.4l1.5.7c.2-.3 15-27.5 14.9-54.5h-1.8q0 2.6-.2 5z",
    className: "j"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1557.8 664.6c5.1 5.6 9.5 10.4 10.9 13.6-4.2-.9-10.1-2.7-18.1-5.5-37.3-13.2-58.1-50.5-64.4-91l34-16c5.7 1.9 37 13.2 28.5 30.9-9.4 19.5-4.3 53.3 9.1 68z",
    style: {
      mixBlendMode: "multiply",
      fill: "url(#g11)"
    }
  }), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "m1544.3 613.8-51.8-6.3c-2.9-8.3-4.9-17-6.3-25.8l34-16c5.7 1.9 37 13.2 28.5 30.9-2.5 5-3.9 10.9-4.4 17.2z",
    className: "d"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "m1376.4 355.7 25.2 10.6 11.2 69 175.6 68.5v103.5s-32.1-6.5-58.5-17.7c-26.3-11-29.9 4.3-65.9 13.2-35.9 8.8-91.6 5.4-111.6-16.7s-53.7-76.9-53.7-76.9l-19.5-95.9 4-17.8z",
    className: "c"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1523 470.5c74.5 19.3 87.2 21.7 107.2 49.6 20 27.8 1 101.6-24 97.4-25-4.4-39-28.3-40.8-60-2-31.8-15.4-50.3-31.9-64.2 0 0-84.9-42.1-10.5-22.8z",
    style: {
      fill: "url(#g12)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1571.3 554.9c.8 30.5 4.5 42.7 15.9 54-13.2-10.5-20.6-28.9-21.8-51.4-1.8-30.6-14.4-48.9-30.1-62.6 1.2-12.1 2.2-20.2 2.2-20.2s17.1 7.2 17.4 32.7c0 0 15.4 16.7 16.4 47.5z",
    style: {
      mixBlendMode: "multiply",
      fill: "url(#g13)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1606.2 617.5c-25-4.4-39-28.3-40.8-60-2-31.8-15.4-50.3-31.9-64.2 0 0-84.9-42.1-10.5-22.8 15.6 4 28.4 7.3 39.3 10.3-16-4.3-9.6 23.9 16.3 36.7 23.5 11.5 52.7-2 33-17.4 6.9 5 12.4 11.2 18.6 20 20 27.8 1 101.6-24 97.4z",
    style: {
      mixBlendMode: "multiply",
      fill: "url(#g14)"
    }
  }), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M1642.3 655.3c-2.7 29.9 12.9 39.7 12.9 39.7 3.3 36.9-7.1 52.4-7.1 52.4-2.7-34.1-27.4-79-27.4-79s22.9-26.7 21.6-13.1z",
    className: "c"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1461.3 444.6c75.4 29 97.2 25.1 86.7 74.7-10.4 49.4-50.4 78-95.8 79.6-45.4 1.5-61.2-20.5-61.2-20.5s-5.1-162.8 70.3-133.8z",
    style: {
      fill: "url(#g15)"
    }
  }), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M1351.1 579.7c-.7 3.4 0 6.8.7 10.1.6 2.5 1.1 5.1 1.8 7.6 1.2 4.6 2.8 9.3 5.5 13.4 1.3 2 2.8 3.9 4.4 5.5 2 1.6 4.4 4 7.3 2.8 2.7-1 4-3.5 5-5.5 1.2-2.5 2.1-4.9 2.8-7.5 1.3-5.3 1.6-10.7 1.9-16.1 0-1.1 1.8-1.1 1.8 0-.4 6.4-.8 13.1-2.9 19.5-.8 2.6-1.9 5.4-3.7 7.6-1.4 1.9-3.5 3.7-6.2 3.8-3.1.2-5.6-2-7.4-3.8-1.9-1.9-3.5-3.9-4.9-6.1-2.8-4.5-4.4-9.5-5.7-14.4q-.9-4.1-1.8-8.3c-.5-3-.9-5.9-.2-9 .1-.9 1.8-.6 1.6.4z",
    className: "c"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M1595.2 613.9c-.6-.2-1.1-.4-1.7-.8 6.9-22.8 14.5-63.3.7-102.2-1.8-5.2-4.1-10.4-6.8-15.6q-2.3-4.3-5.2-8.7 1.4.5 2.6.9 2.5 3.8 4.6 7.8 4.7 9.5 7.8 19.1c12.3 38.2 4.6 77.2-2 99.5zM1529.9 491.5c4.1 8.9 7.2 18.4 7.9 28.1l-2.8 15.5c-.1.5-11.6 34.5-41.5 54.1q-5.3 2.3-10.6 4.2c36.5-17.6 50.3-58.1 50.5-58.6l2.6-15.2c-.7-10.2-4-20.2-8.6-29.4-4-8.1-8.9-15.7-13.9-22q-2.6-3.5-5.1-6.6l3 1.2q2.4 2.8 4.7 6c4.8 6.6 9.8 14.3 13.8 22.7z",
    className: "j"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1478 450.8s20 34.5 14.5 76.7c-5.6 42.3-14.5-76.7-14.5-76.7z",
    style: {
      mixBlendMode: "multiply",
      fill: "url(#g16)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1594.2 510.9c13.8 38.9 6.2 79.4-.7 102.2q-.6-.3-1.1-.7c6.8-22.9 14.6-63.9.4-103.1q-2.5-6.9-6.1-13.9-2.3-4.5-5.2-9 .4.1.7.2 2.9 4.4 5.2 8.7c2.7 5.2 5 10.4 6.8 15.6z",
    style: {
      opacity: 0.5,
      mixBlendMode: "color-dodge",
      fill: "url(#g17)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1548 519.3c-10.4 49.4-50.4 78-95.8 79.6-45.4 1.5-61.2-20.5-61.2-20.5s-5.1-162.8 70.3-133.8c11.6 4.5 22 8.2 31.2 11.4-12.5-4.5-7.6 27.3 24.7 54.5 32.3 27.1 41-12.2 26.5-30.7 7.4 8.4 8.6 19.6 4.3 39.5z",
    style: {
      mixBlendMode: "multiply",
      fill: "url(#g18)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1406.8 404.8s41.8 17.4 63.6 34.4c21.8 17 14.5 103.2 14.5 103.2h-47.2z",
    style: {
      fill: "url(#g19)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1484.9 542.4h-47.2l-30.9-137.6s17 7 34.9 16.7c-18.3-9.2-3.3 42.6 18 63.7 21.1 21.2 21.8-12.5 20.5-28.9 9.4 30.7 4.7 86.1 4.7 86.1z",
    style: {
      mixBlendMode: "multiply",
      fill: "url(#g20)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1478 511.4s-2.5 15.4-2.5 15.8c0 .2-16.8 2.9-23.5.9-4.3 17.1-11.6 35.5-22 45.1-19 17.8-30.9 12.7-30.9 12.7l30.9-90.7 26.4-2.5c.5 5.7-.3 15.8-2.5 27.2 10.6-8.8 24.1-8.5 24.1-8.5z",
    style: {
      mixBlendMode: "multiply",
      fill: "url(#g21)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1393.2 529.7 63.6-34.5c4.5 11.4 29.2 7.2 29.2 7.2s21.4 42.1 58 30.7c-14.4 40.9-50.8 64.4-91.8 65.8-45.4 1.5-61.2-20.5-61.2-20.5s-.7-22.1 2.2-48.7z",
    style: {
      mixBlendMode: "multiply",
      fill: "url(#g22)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1456.8 490.3c0 8.1-10.5 56.8-35.5 83-24.9 26.3-30.3 2.4-48.5 7.4-18.2 5.1-10.5 17.4-37.3 0-26.7-17.4-55.4-60.7-55.4-68 0-7.4 5.1-66.9-8.2-117.9 0 0 6.1-2.6 15.5-6.6.9 12.6 2.5 28.7 4.1 36.3 2.6 13.5 46.8 89.7 64.4 108.6 0 0 1.4-10.8 4.2-25.9 2.6-15 34.5-104 38.1-116.8 3.7-12.6-7.8-30-7.8-30l-46.6 4.8c27.2-10.8 52.6-20 56.1-18.4 8.3 3.5 12.9 13.1 12.9 13.1 5.4 104.8 44 122.3 44 130.4z",
    style: {
      fill: "url(#g23)"
    }
  }), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "m1307.8 470.5-26.9 20v-2l26.8-19.7 8 3.7q.6 1.3 1.3 2.5zM1438.9 464.9q-4.9.2-8.9 2.2c-9.1 4.5-11.8 14.5-11.8 14.6l-.3 1.1-12.4-7.7-25.7-15.6-6.5 4.7q.4-1.3.9-2.6l5.6-4.1 26.4 16.2 10.6 6.5c.9-2.8 4.3-10.5 12.4-14.5q1.1-.4 2.1-.8.5-.2 1.1-.3.5-.3 1.2-.4.7-.2 1.5-.3.4-.2.7-.2 1-.1 1.9-.2h.3q.4.7.9 1.4z",
    className: "j"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1280.1 512.7c59.1 84.1 176.7-22.4 176.7-22.4 0 8.1-10.5 56.8-35.5 83-24.9 26.3-30.3 2.4-48.5 7.4-18.2 5.1-10.5 17.4-37.3 0-26.7-17.4-55.4-60.7-55.4-68z",
    style: {
      mixBlendMode: "multiply",
      fill: "url(#g24)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1277.7 424.7c-1.4-9.9-3.2-20.2-5.8-29.9 0 0 6.1-2.6 15.5-6.6.8 10.1 1.9 22.4 3.1 30.9l-6.3 2.1z",
    style: {
      mixBlendMode: "multiply",
      fill: "url(#g25)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1412.8 359.9c5.4 104.8 44 122.3 44 130.4 0 8.1-10.5 56.8-35.5 83-24.9 26.3-30.3 2.4-48.5 7.4-18.2 5.1-10.5 17.4-37.3 0-15.2-9.9-30.9-28.1-41.8-43.2 16.4 23.7 58.7 44.2 78.1 34.9 19.5-9.3 69.5-50.3 45.5-90.9-24-40.7-20.2-67.3-20.2-67.3l-6.3-1.6c3.6-10.6 6.4-18.9 7.4-22.2 3.7-12.6-7.8-30-7.8-30l-31.8 3.3-2.2-3.4c22-8.5 40.5-14.8 43.5-13.5 8.3 3.5 12.9 13.1 12.9 13.1z",
    style: {
      mixBlendMode: "multiply",
      fill: "url(#g26)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1315.4 472.2q.1.2.3.3l-8-3.7-26.8 19.7q.1-.9.1-1.7l25.6-19z",
    style: {
      opacity: 0.5,
      mixBlendMode: "color-dodge",
      fill: "url(#g27)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1437.5 462.6q.2.4.5.9h-.3q-.9.1-1.9.2-.3 0-.7.1-.8.2-1.5.4-.7.1-1.2.4-.6.1-1.1.3-1 .4-2.1.8c-8.1 4-11.5 11.7-12.4 14.5l-10.6-6.5-26.4-16.2-5.6 4.1q.4-1.2.8-2.2l3.6-2.7 27.6 16.9 9.5 5.8c.9-2.9 4.3-10.5 12.4-14.5q4.3-2.1 9.4-2.3z",
    style: {
      opacity: 0.5,
      mixBlendMode: "color-dodge",
      fill: "url(#g28)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1412.8 359.9c-1 30.8-46.8 119.6-56.9 173.2 0 0 1.4-10.8 4.2-25.9 2.6-15 34.5-104 38.1-116.8 3.7-12.6-7.8-30-7.8-30l-46.6 4.8c27.2-10.8 52.6-20 56.1-18.4 8.3 3.5 12.9 13.1 12.9 13.1z",
    style: {
      mixBlendMode: "multiply",
      fill: "url(#g29)"
    }
  }), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M1451.5 515.4c-4.5 15.2-12 34.2-22.9 49.1l-.8.8s-3.3-33.9 23.7-49.9z",
    className: "d"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1284.5 402.3c-.4-2.2.9-4.8 3.4-7.4 1 11 2.2 23.3 3.6 29.6 2.5 12.2 38.8 75.9 58.8 101.8-11.3-13.7-37.3-46.1-53-73.3-20.7-35.5-9.9-31.1-12.8-50.7z",
    style: {
      mixBlendMode: "multiply",
      fill: "url(#g30)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1272.5 396.1c.4 5.2.9 10.4 1.5 15.7.8 7.9 2.2 16.2 7.7 22.8 2.6 3.2 7.1 6.7 12 5.3 4.4-1.3 4.6-6.1 4.6-9.4 0-.9 1.8-.9 1.8 0 0 4.1-.6 9.4-6.1 10.8-5 1.4-9.7-1.5-12.7-4.7-3.2-3.4-5.4-7.4-6.6-11.6-1.4-4.3-2.1-8.7-2.5-13.2-.6-5.3-1.1-10.5-1.5-15.7-.2-1 1.6-1 1.8 0z",
    style: {
      fill: "url(#g31)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1234.3 347.9s12.1-10.9 15-20.4c8.6-28.7 66.6-43.7 96.7-38.6 29.9 4.9 41 27.8 62.4 27 0 0 1.8 18.9-7.9 55-1.1 3.8-3.4 7.2-7 9.6-6.8 4.3-18 13.5-21.7 27-4.3 15-8.7 29.8-25.7 37.8-31.4 14.7-38.7 4.7-39.1.8-.6-3.9-3.3-19-3.9-24.3-.3-3.8-11-10.4-28.6-17.1-3.7-1.5-7.3-3.4-9.9-6-7.3-7.6-19.4-28-30.3-50.8z",
    style: {
      fill: "url(#g32)"
    }
  }), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M1290.4 295.3q1-.3 1.9-.7c-2.4 10.8-6.4 30.3-6.4 50.2l22.6 18 1.1.9 17.4-26c-1.1-2.8-9.1-25.1-12.3-48.4q.8-.1 1.8-.2c3.4 24.7 12.1 48.3 12.3 48.5l.1.3-18.9 28.2-25.8-20.8-.1-.2c0-19.5 3.7-38.7 6.3-49.8z",
    className: "j"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m1379.8 330.5-6.2-30.5c12.3 7.8 21.5 16.3 34.8 15.9 0 0 1.8 18.9-7.9 55-1.1 3.8-3.4 7.2-7 9.6-6.7 4.3-17.8 13.5-21.7 26.9 3.7-18.5 12.1-63.5 8-76.9z",
    style: {
      mixBlendMode: "multiply",
      fill: "url(#g33)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1234.3 347.9s7.6-6.9 12.1-14.4l5.1 16.8s20.3 51.2 37 60.3c-4-1.8-8.7-3.9-14-5.9-3.7-1.5-7.3-3.4-9.9-6-7.3-7.6-19.4-28-30.3-50.8z",
    style: {
      mixBlendMode: "multiply",
      fill: "url(#g34)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1400.5 370.9c-1.1 3.8-3.4 7.2-7 9.6-6.8 4.3-18 13.5-21.7 27-2.8 9.4-5.4 18.6-11.3 26.3 12.3-18.2-2.4-51.2 5-65.8 8.2-16.1-2.1-6.3-2.1-6.3s7.6-8-6.1-20.5c-13.5-12.5-33.5-33.2-53.1-30.3q-2.3.2-4.5.7c-12.9 3-20.7 13.4-23.6 24.9-4.2 12.5-4.3 25.5-6.5 29.6-4.4 8.1 2.3 13.7 2.3 13.7v2.1c3.6 14.4 26.1 26.6 30.8 38.6-2.4-3.9-12.6-9.9-28.2-15.8-3.7-1.5-7.3-3.4-9.9-6-7.3-7.6-19.4-28-30.3-50.8 0 0 12.1-10.9 15-20.4 8.6-28.7 66.6-43.7 96.7-38.6 29.9 4.9 41 27.8 62.4 27 0 0 1.8 18.9-7.9 55z",
    style: {
      mixBlendMode: "multiply",
      fill: "url(#g35)"
    }
  }), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "m1495.4 550.6-10.9 24.6-16.1 43.8h-26.9l-3.6-28.3-2.2-8.1z",
    className: "c"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1307.5 448.1c-2.5-13.4-.8-35.6-.8-35.6l-3.9-13.7.7-1.8 3.2 3.8c-.1-25.4 26.5-12.5 27.6-1.5.1 1.8.4 2.7.7 2.9-.3 2.3-.4 4.8-.4 7.3.4 10 1.6 23 2.2 28.6-17.8 1.2-30 5.9-29.3 10z",
    style: {
      opacity: 0.7,
      mixBlendMode: "screen",
      fill: "url(#g36)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1314.7 289.3c3.2 23.3 11.2 45.6 12.3 48.4l-17.4 26-1.1-.9 17.2-25.9c-.9-2.8-8.7-24.4-12-47.3q.6-.2 1-.3z",
    style: {
      opacity: 0.5,
      mixBlendMode: "color-dodge",
      fill: "url(#g37)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1283 344.5v-.3c0-18.7 3.4-37.1 6-48.4q.7-.3 1.4-.5c-2.6 11.1-6.3 30.3-6.3 49.8l.1.2 24.7 19.9z",
    style: {
      opacity: 0.5,
      mixBlendMode: "color-dodge",
      fill: "url(#g38)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1492.5 513.1c28.2 13.2-9.4 87.1-49.8 76.5-40.4-10.4 11.1-94.7 49.8-76.5z",
    style: {
      fill: "url(#g39)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1434.2 596.3 3.7-5.3s4.8 17.4 15 15.1c10.2-2.5 31.6-30.9 31.6-30.9l4.7 5.7s.3 78.9-25.8 129.2c-29.2 56.8-34.1-11.7-33.2-56.7.7-44.9 4-57.1 4-57.1z",
    style: {
      fill: "url(#g40)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1379.8 330.5s22.5 14.1 7.7-21.1c-14.9-35.2-7.7 21.1-7.7 21.1z",
    style: {
      mixBlendMode: "multiply",
      fill: "url(#g41)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1277.4 326.2s-7.3-8.9-13.3-17.7c9.5-7.1 22-12.5 35.3-15.9-10.2 4-19.2 17.7-22 33.6z",
    style: {
      mixBlendMode: "multiply",
      fill: "url(#g42)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1335.8 305.1s19.3-10.5 21.5-10.5c2.2 0 28.7 23.6 28.7 23.6l-6.2 12.3c-13.2-8.9-35.2-7-35.2-7z",
    style: {
      mixBlendMode: "multiply",
      fill: "url(#g43)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1271.5 334.8s-9.8-.7-20 15.5l-4.3-9.7 12.2-23 12.1-2.7z",
    style: {
      mixBlendMode: "multiply",
      fill: "url(#g44)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1274.8 377.2c6.6-5 8.2-5.7 26.5-3.5 18.4 2.1 11.3 3.2 29.4-6.7 17.9-10.1 16.1-7.8 32.7-5.3 16.7 2.6-25.7 25.9-25.7 25.9s-2.3 22.6-3.4 11.7c-1.1-11-27.7-23.9-27.6 1.5l-6.5-7.7z",
    style: {
      mixBlendMode: "multiply",
      fill: "url(#g45)"
    }
  }), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M1394.8 813.6c16.3-37.5 27.6-25.8 27.6-25.8 15.8-11.4 24 4.7 24 4.7 16.5-5 22.9 21.1 22.9 21.1-48.1 15.6-74.5 0-74.5 0z",
    className: "d"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M1334.6 409.5s-.7-19.1 0-29.6c.6-10.7.5-12 8.2-15.1 7.8-3.1 11.3-3.1 20.6-3.1l8.4-11.8s-.7 3.4-3.2 11.7c-2.5 8.1-3.6 8.8-16.8 20.6-13.1 11.8-14.1 12.9-17.2 27.3zM1286.4 389.9c-10.2-3.4-11.3-4-16-8.4-4.8-4.2-7-7.8-7-7.8l8.5 6.1c3.9-3.7 4.9-4.5 13.3-4.7 8.2-.2 10.2 1.3 15.8 9.9 5.7 8.7 6 9.9 5.7 15.8-.3 5.9 0 11.7 0 11.7-7.5-17.6-9.9-19.2-20.3-22.6z",
    className: "c"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1344.6 323.5s-5.8-1.5-10.6-5.1c-4.8-3.6-6.2-14.9-8.3-30.3 0 0 11.1-15.7 28.7-33.9 16.2-16.8 21.7-18.7 25.5 2.2 3.9 20.9 8.6 57.5 9 61.3.6 4-9.1 12.8-9.1 12.8s-.5-5.4-8-11.1c-7.4-5.6-26.9-4.8-26.9-4.8z",
    style: {
      fill: "url(#g46)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1266.4 327.3c-11.9 2.9-14.9 23-14.9 23s-5.5-.4-7.4-4.5c-2-4.1-12.6-29.5-19.1-49.9-6.5-20.6-7.4-35.1 12.6-24.1 20 11.2 46.9 25.6 46.9 25.6-11.5 12.5-4.4 24.3-7.1 28.8-2.6 4.5-5.9 8.6-5.9 8.6z",
    style: {
      fill: "url(#g47)"
    }
  }), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M1586.9 606.9c-15.6-30.4-21.3-78.8 10.2-89 31.4-10.2-10.2 89-10.2 89z",
    className: "d"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M1342.8 364.8c6.7-2.7 10.2-3 17.1-3.1.2 1 .2 3.1-2.7 5.6-4.2 3.5-13.7 11.8-15.3 9.5-1.7-2.2-2.9-10.2.9-12zM1277.3 376c1.7-.6 4-.8 7.9-.9 5.2-.2 8 .4 10.6 3 3.6 9.6 1 6.9-11.3 3.4-5.5-1.6-7.3-3.7-7.2-5.5z",
    className: "Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1501.6 525c5.3 22.8-20.8 65.6-50.9 65.7-5.2 0-9.9-3.2-11-7.5-6-22.7 22.6-64.3 50.6-65.8 5.4-.3 10.4 3.1 11.3 7.6z",
    style: {
      mixBlendMode: "multiply",
      fill: "url(#g48)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1309.6 450.5c-1-.9-1.7-1.7-2.1-2.4-.8-5 18-11 42.6-10.1 5.3.2 10.1-3.9 14.1-9.9-3.8 7-9.2 13-18.1 17.2-22 10.2-32.2 8.4-36.5 5.2z",
    style: {
      mixBlendMode: "multiply",
      fill: "url(#g49)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1603 515.8c34.2-5.9 50.4 68.4 47.6 100-2.6 31.7-8.3 36.6-5.5 51.1 1.8 9.6 18.1 27.6-18.1 7.5-24.3-13.6-43.2-59.4-45.8-103-2.7-43.7 12.7-54.1 21.8-55.6z",
    style: {
      fill: "url(#g50)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1266.4 327.3c-11.9 2.9-14.9 23-14.9 23-13.8-22.9-24-45.1-28.3-60.6-1.1-3.8-1.8-7.2-2.2-10.2v-.7q-.1-.8-.1-1.5v-2.2c.9-12.1 33.1 27.8 45.5 52.2z",
    style: {
      mixBlendMode: "multiply",
      fill: "url(#g51)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1605.5 525.3c4.7-5.9 15-5.9 20.1-.4 18.7 20.2 27.1 67.3 25 90.9-2.6 31.7-8.3 36.6-5.5 51.1.8 4.4 4.6 10.4 5.1 13.8-2.3-1.2-5.1-2.6-8.3-4.5-24.3-13.5-43.2-59.3-45.9-103-1.7-26.2 3.3-40.4 9.5-47.9z",
    style: {
      mixBlendMode: "multiply",
      fill: "url(#g52)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1460.6 578.9c-6-1.7-3.7-13.8 5.2-27.1 8.8-13.3 20.8-22.6 26.9-20.9 5.9 1.7 3.7 13.8-5.1 27-8.9 13.3-21 22.7-27 21z",
    style: {
      fill: "url(#g53)"
    }
  }), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M1459.3 564c1.3-3.7 3.6-7.8 6.5-12.2 4.5-6.9 10.2-12.8 15.3-16.7 2.5-1.4 4.8-2.1 6.6-1.6 4.8 1.4 3 11.4-4.3 22.2-7.2 10.9-17 18.6-21.9 17.3-2.8-.9-3.5-4.3-2.2-9z",
    className: "a6"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M1459.8 567.3q-.5-.2-.9-.4 0-1.3.4-2.9c1.3-3.7 3.6-7.8 6.5-12.2 4.4-6.6 9.6-12.3 14.6-16.1q.1 0 .4.1c5 1.3 4.3 9.6-1.5 18.3-5.8 8.6-14.5 14.5-19.5 13.2z",
    className: "Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1633.9 600.2c-7.7 3.2-18.6-9.3-24-27.6-5.5-18.3-3.6-35.7 4.2-38.8 7.8-3.1 18.6 9.3 24.1 27.6 5.4 18.4 3.6 35.8-4.3 38.8z",
    style: {
      fill: "url(#g54)"
    }
  }), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M1616.5 588.2c-2.6-4.4-4.8-9.6-6.6-15.6-2.9-9.6-3.7-19-2.7-26.2.9-3.3 2.6-5.6 4.8-6.6 6.5-2.4 15.3 7.7 19.7 22.7 4.6 15 3.1 29.3-3.4 31.8-3.5 1.4-7.9-1-11.8-6.1z",
    className: "a6"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M1620.7 590.6q-.8.3-1.7.3-1.2-1.1-2.5-2.7c-2.6-4.4-4.8-9.6-6.6-15.6-2.7-9.3-3.7-18.2-2.9-25.2q.3-.2.7-.3c6.4-2.6 14.5 5.1 18.1 17.2 3.6 11.9 1.4 23.7-5.1 26.3z",
    className: "Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1301.3 373.7c-3.2-.4-5.8-.6-8-.9-26.8-3.4-24.4-54 6.4-61.2 30.9-7.1 65.1 36.6 31 55.4-18.1 9.9-11 8.8-29.4 6.7z",
    style: {
      opacity: 0.7,
      mixBlendMode: "screen",
      fill: "url(#g55)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1334 318.4c-4.8-3.6-6.2-14.9-8.3-30.3 0 0 11.1-15.7 28.7-33.9 8.6-8.9 14.2-13.6 18.1-12.9q.4.2.7.3c-9.1.5-44.4 71.2-39.2 76.8z",
    style: {
      opacity: 0.7,
      mixBlendMode: "screen",
      fill: "url(#g56)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1277.4 326.2q-.4.8-.9 1.6c1.5-3.5-34.6-57.4-48.7-59.6 2.5.2 5.6 1.4 9.8 3.6 20 11.2 46.9 25.6 46.9 25.6-11.5 12.5-4.4 24.3-7.1 28.8z",
    style: {
      mixBlendMode: "multiply",
      fill: "url(#g57)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1573.9 768.6-6.2-.4c12.7-20.6 8.3-76 .1-85 1.4-.9 2.8-1.2 4.3-1.2 9.5 0 15.9 64.5 1.8 86.6z",
    style: {
      mixBlendMode: "multiply",
      fill: "url(#g58)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1674.3 783.7-5.6-.5c9.5-34-6.4-88.7-17.4-95.1 1.1-.6 2.5-.7 3.9-.7 10.9.5 29.5 60.3 19.1 96.3z",
    style: {
      mixBlendMode: "multiply",
      fill: "url(#g59)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1489.2 580.9s.3 78.9-25.8 129.2c-9.9 19.4-17.1 24.2-22.2 20.2 3.6-3.2 8.7-21.2 10.3-31 16.7-103.8 27.6-116.4 27.6-116.4l-.4-.4c3.5-4.3 5.8-7.3 5.8-7.3z",
    style: {
      mixBlendMode: "multiply",
      fill: "url(#g60)"
    }
  }), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M1520.8 768.6c.6-8.3 7.2-16.8 17-19.8 9.6-3 13.8 5.9 13.8 5.9 13.6-6.7 22.3 13.9 22.3 13.9-48.7 12.6-53.1 0-53.1 0zM1643.6 795.1c-27.2-.4-27.7-12.8-27.7-12.8 13.2-24.1 26.3-15.3 26.3-15.3 12.6-5.5 20.6 7 20.6 7 8.1-3.7 11.5 9.7 11.5 9.7s-3.4 11.7-30.7 11.4z",
    className: "d"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M1394.8 813.6q1.3-3 2.5-5.6c0 .1 3.8 6.9 11.3 5.6 0 0 0-16.6 13.8-25.8 0 0-8.2 13.8-6.4 27.2 0 0 9.5 2.3 19 0 0 0-1.9-16.5 11.4-22.5 0 0-8 10.3-4.1 22.3 0 0 12.4 2.2 22.1.3-45 13.1-69.6-1.5-69.6-1.5zM1520.8 768.6q0-1.6.4-3.1c.2 0 5.8 5.2 14.2 4.7 0 0 .8-11.3 16.2-15.5 0 0-9 4.2-10.1 15.6 0 0 10.3 2.2 32.4-1.7-48.7 12.6-53.1 0-53.1 0zM1615.9 782.3q1.1-1.9 2.2-3.6s2.3 9 11.1 9.5c0 0 1.4-14.2 13-21.2 0 0-7.9 11-7.9 22.4 0 0 8.5 3.2 16.6 1.2 0 0 1.8-12.6 11.9-16.6 0 0-5.7 6.7-5.4 16 0 0 12.9.8 16.9-6.3 0 0-3.4 11.7-30.7 11.4-27.2-.4-27.7-12.8-27.7-12.8z",
    className: "e"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1417.3 481.5c1.3 2.2 2.4 4.3 3.2 6.5-2.3-2.7-6.5-3.6-13.7.6-19 11.1-43.5 18.7-50 40.6 2.2-10.3 5.5-21.8 9.5-33.6-1.3 4.5-1.7 12.3 13.9 3.1 21-12.4 32.4-21.3 26.5-38.1 2.8 6.4 6.2 13.4 10.6 20.9z",
    style: {
      fill: "url(#g61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1349.5 525.3s-41.8-23.7-54-28.7c-12.1-4.9-15.2 10-15.2 10 .5-7.9 1-22 .6-39.1 2.5 20.7 65 55.9 46.1 29.1 8.8 11.8 16.9 22.1 22.5 28.7z",
    style: {
      fill: "url(#g62)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1467.4 526.8c.4-.4.8-.7 1.3-.9-10.4 7.4-19.2 18.6-24.6 30 0 0 9.7-27.9 1.9-24.5q-1.4.7-3.7 2.8 2.3-2.9 4.8-5.6c2.9-3.2 6-6 9.3-8.5-8 10.2-1.5 16.3 11 6.7z",
    style: {
      fill: "url(#g63)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1462.6 639.1c-2.8 12.5-5.7 27.9-8.8 46.6 0 0-18.5-77.9-23.6-34.3.5-24.5 1.6-39 2.6-46.8.7 16.3 20.3 72.8 29.8 34.5z",
    style: {
      fill: "url(#g64)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1596.7 581.3s-13.4-50.9-15.8-18.1c-.2-18.2 3.1-29.6 7.5-36.8-4.1 9.1 1.7 44.9 8 23.8-.7 6.4-1 14-.4 23q.3 4.1.7 8.1z",
    style: {
      fill: "url(#g65)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1360.1 284.3c18.9-10.5 20.8 27 6.2 29.1-11.2 1.8-17.7-22.8-6.2-29.1z",
    style: {
      mixBlendMode: "multiply",
      fill: "url(#g66)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1360.1 284.3c10.9-6.6 17.5 27.3 6.2 29.1-11.2 1.9-17.4-22.4-6.2-29.1z",
    style: {
      fill: "url(#g67)"
    }
  }), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M1372.4 316.5c-3.6-.3.6-7.8 2.7-7.9 2.9-.4.6 8.1-2.7 7.9z",
    className: "c"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M1358.7 285.2c-8.7 7.3-3.7 27.5 5.8 28.3 5.8-6.2 1.8-26.9-5.8-28.3zM1371.4 315.4q-.3 0-.4-.1c-.3-2.1 2.6-6.6 4.1-6.7q.3-.1.4 0c.4 2.2-1.5 6.9-4.1 6.8z",
    className: "al"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1379.8 330.5s-.5-5.4-8-11.1c-7.4-5.6-26.9-4.8-26.9-4.8.1-17.4 28.1-76.6 33.5-65q.7 3 1.5 6.8c.9 4.5 1.7 9.6 2.5 14.8 1.5 18.4 1 42.9-2.6 59.3z",
    style: {
      mixBlendMode: "multiply",
      fill: "url(#g68)"
    }
  }), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M1425.9 457.2c1 3.2.1 6.2-1.7 6.5-1.9.5-4.2-1.8-5.2-5s-.2-6.1 1.6-6.6c2-.3 4.3 1.9 5.3 5.1zM1609.1 503.4c-.8.9-3.5.4-5.9-1.1-2.5-1.6-3.9-3.6-3.2-4.4.8-.9 3.4-.3 5.9 1.2 2.5 1.5 3.9 3.5 3.2 4.3zM1640.3 613.5c.5 2.8-.4 5.1-2 5.4-1.6.2-3.4-1.8-4-4.5-.5-2.8.5-5.1 2-5.4 1.6-.2 3.4 1.8 4 4.5zM1536.8 618.4c-1.4 0-2.6-2.1-2.6-4.7 0-2.7 1.2-4.8 2.6-4.8 1.5 0 2.6 2.1 2.6 4.8 0 2.6-1.1 4.7-2.6 4.7zM1481.5 631.1c-.4 2.5-1.5 4.3-2.5 4.2-1-.1-1.4-2.2-1-4.7.4-2.4 1.5-4.3 2.5-4.2 1 .1 1.4 2.2 1 4.7z",
    className: "c"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M1482 628.9c4.3.8 8.3-1.6 10.8-4.4 2.2-2.6 3.9-5.5 5.4-8.3 1.5-3.2 2.7-6.4 3.6-9.7 1.8-6.3 2.2-12.9 1.3-19.3-.1-1.1 1.7-1 1.8 0q.7 6 .2 12c-.9 7-3.2 13.8-6.8 20-3 5.6-8.3 12.7-16.7 11.1-1.2-.1-.7-1.7.4-1.4zM1639.3 521.3c-.3 3.5-1.1 6.9-3.6 9.7l-.1.1q-.3-1-.7-1.9c1.9-2.8 2.6-6 2.6-9.2 0-3.4-.3-6.8-1.6-10-1.3-3-3.6-5.5-6.8-7.3-7-3.9-15.9-3.5-23.6-1.7-1.1.2-1.5-1.2-.4-1.4 5-1.2 10.2-1.8 15.4-1.2 8 1 15.1 5.4 17.4 12.1 1.3 3.5 1.5 7.3 1.4 10.8z",
    className: "c"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWolf);
export default __webpack_public_path__ + "static/media/wolf.2965b12539588186bb3a299b0fbf1aab.svg";
export { ForwardRef as ReactComponent };